import { Link, useNavigate } from "react-router-dom";
import MobFixedHeader from "../../components/Header/MobFixedTopHeader";

function MobileProfileTopNavigation({ pageTitle }) {
  const navigate = useNavigate();
  
  const handleBack = (pageTitle) => {
      if (pageTitle === "Profile") {
        navigate('/');
      } else {
        navigate('/profile');
      }
  };
  return (
    <MobFixedHeader title={pageTitle} onBack={(pageTitle)=>{handleBack(pageTitle)}} />
  );
}

export default MobileProfileTopNavigation;
